import {Pipe, PipeTransform} from '@angular/core';
import _ from 'lodash';
import {LocaleService} from "../services/locale.service";

@Pipe({
    name: 'sortBy',
    standalone: false
})
export class SortByPipe implements PipeTransform {

	constructor(private localeService: LocaleService) {
	}

	transform(value: any[], order = '', column: string = ''): any[] {
		if (!value || order === '' || !order) {
			return value;
		}
		if (!column || column === '') {
			return value.slice().sort((a, b) => a.localeCompare(b, this.localeService.currentLocale(), { sensitivity: 'base' }))
		}
		if (value.length <= 1) {
			return value;
		}

		// @ts-ignore
		return _.orderBy(value, [item => this.getValueFrom(item, column)], [order]);
	}

	protected getValueFrom(item: any, column: string): any {
		const value = _.get(item, column);
		if (value && typeof value === "string") {
			return value.toLowerCase();
		} else {
			return value;
		}
	}
}
